module.exports = __webpack_public_path__ + "static/media/tm.f9ef08a8.svg";